var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SearchPagination"},[_c('LLPagination',{attrs:{"loading":_vm.pending,"total":_vm.total,"current":_vm.current,"per-page":_vm.perPage},on:{"goToPage":_vm.goToPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }